import flatten from 'flat';
import get from 'lodash/get';
import { FormErrors, RegisteredFieldState } from 'redux-form';
import { CheckoutFormData, CheckoutFormErrorType } from '../state/form';

export const flattenFormData = (
    formData?: Array<unknown> | Record<string, unknown>,
): Record<string, unknown> =>
    flatten(formData ?? {}, {
        safe: true,
    });

export const focusOnFirstError = (
    registeredFields: string[],
    errors:
        | FormErrors<CheckoutFormData, CheckoutFormErrorType>
        | undefined = {},
) => {
    const errorFieldNames = flattenFormData(errors as CheckoutFormErrorType);

    registeredFields.find((field) => {
        if (errorFieldNames[field]) {
            const elem: HTMLElement | null = document.querySelector(
                `input[name="${field}"], select[name="${field}"], input[aria-invalid="true"], select[aria-invalid="true"]`,
            );
            if (elem) {
                elem.focus();
                return true;
            }
        }
        return false;
    });
};

export const getActiveFieldsPerSectionNamespace = (
    fields: RegisteredFieldState[] = [],
) =>
    Object.keys(fields).reduce((fieldsPerNamespace, key) => {
        if (!get(fields, key).count) {
            return fieldsPerNamespace;
        }

        const keyParts = key.split('.');
        const namespace = keyParts[0];
        const field = keyParts[1];
        const fieldsInKeyNamespace = get(fieldsPerNamespace, namespace);

        return {
            ...fieldsPerNamespace,
            [namespace]: fieldsInKeyNamespace
                ? [...fieldsInKeyNamespace, field]
                : [field],
        };
    }, {});

export const hasErrorInFields = (
    fields: Array<string>,
    syncErrors?: FormErrors<{}, string>,
    asyncErrors?: FormErrors<{}, string>,
) =>
    fields?.some((error) => {
        return !!get(syncErrors, error) || !!get(asyncErrors, error);
    }) ?? false;
